import React, { useState } from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import BillsCard from "./BillsCard";
import AddBill from "./AddBill";
import EditBill from "./EditBill";

const ManageBillsModal = (props) => {
  const { currentProperty } = props;
  const { bills, modal, handleModal } = useStateContext();
  const [currentBillId, setCurrentBillId] = useState(null);

  const currentPropertyBills = bills.filter(
    (x) => x.propertyId === currentProperty.id
  );

  const currentBill = currentPropertyBills.find((x) => x.id === currentBillId);

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      {modal.addBill && <AddBill currentProperty={currentProperty} />}
      {modal.editBill && <EditBill currentBill={currentBill} />}
      {/* <div className="flex justify-center mt-5">Manage Bills</div> */}
      <div
        className="flex justify-center text-blue-500 hover:text-blue-700 cursor-pointer mt-10"
        onClick={() => handleModal("addBill")}
      >
        + Add Bill
      </div>
      <BillsCard
        bills={currentPropertyBills}
        setCurrentBillId={setCurrentBillId}
      />
      <div className="flex justify-center w-full mt-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("manageBills")}
        />
        {/* <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Split"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => {}}
        /> */}
      </div>
    </div>
  );
};

export default ManageBillsModal;
